import React from 'react';
import { Route } from 'react-router-dom';

const NotFound = () => (
  <Route
    render={({ staticContext }) => {
      if (staticContext) {
        // eslint-disable-next-line no-param-reassign
        staticContext.status = 404;
      }

      return <h1>404 : Not Found</h1>;
    }}
  />
);

export default NotFound;
